import React from 'react';
import Card from '@material-ui/core/Card';
// import BoatIcon from '@material-ui/icons/DirectionsBoat';
import Typography from '@material-ui/core/Typography';
// import { Link } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import { ListItem, ListItemText, List/*, ListItemSecondaryAction*/ } from '@material-ui/core';
// import moment from 'moment';
import IconCitizen from './IconCitizen'
import { makeStyles } from '@material-ui/core/styles';

import CardIcon from './CardIcon';

import Link from '../../components/Link';

const useStyles = makeStyles(
  theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      //backgroundColor: theme.palette.background.paper,
    },
    main: {
      flex: '1',
      marginRight: '1em',
      marginTop: 20,
    },
    main_mobile: {
      flex: '1',
      // marginRight: '1em',
      marginTop: 20,
    },
    card: {
      overflow: 'inherit',
      textAlign: 'right',
      padding: 16,
      minHeight: 52,
    },
    inline: {
      display: 'inline',
    },
    cardIcon: {
      float: 'left',
      margin: '-20px 20px 0 15px',
      zIndex: 100,
      borderRadius: 3,
      border: '2px solid #ff8400'
    }
  })
);

const PublicPastCampaigns = ({ value, mobile, ...rest }) => {

  const classes = useStyles(rest);
  const translate = useTranslate();

  return (
    <div className={mobile ? classes.main_mobile : classes.main}>
      <CardIcon style={{
        // width: 30,
        // height: 30,
        // handColor: '#000',
        // wavyColor: '#000'
      }}
        cardIcon={classes.cardIcon}
        Icon={IconCitizen}
        bgColor="#f0e499"
      />
      <Card className={classes.card}>
        <Typography className={classes.title} color="textSecondary">
          {translate('containers.dashboard.past_campaigns')}
        </Typography>

        <Typography type="headline" component="h2">
          {(value && value.length) || 0}
        </Typography>

        {value && value.map((campaign, index) => (
          <Link
            to={`${campaign.permlink}`}
            key={index}
          >
            <List className={classes.root}>
              <ListItem button
                className={classes.content}
              >
                <ListItemText
                  primary={`${campaign.name}`}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        {'Start Date: '}
                      </Typography>
                      {/* {moment(campaign.begintimestamp).utc().format('DD-MM-YYYY, HH:mm:ss') + ' GMT'} */}
                      {new Date(campaign.beginDate).toLocaleDateString()}
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Link>
        ))}
      </Card>
    </div>
  )
};

export default PublicPastCampaigns;